import React, { useEffect, useState } from "react";
import LinksComponent from "../../../components/Tenant/LinksComponent/LinksComponent";
import DataTableComponent from "../../../components/Tenant/DataTableComponent/DataTableComponent";
import { useLocation, useNavigate } from "react-router-dom";
import SelectComponent from "../../../components/Tenant/SelectComponent/SelectComponent";
import CustomExport from "../../../components/CustomExport/CustomExport";
import {
  useFetchRedemptionHistoryCountForTDSMutation,
  useFetchRedemptionHistoryForTDSMutation,
} from "../../../features/tenant/redeemptionHistory/redemptionHistoryApi";
import { hasPermission } from "../../../utils/hasPermission";
import { getVendorName } from "../../../utils/getVendorName";
import { formatter } from "../../../utils/numberFormatter";

const redemptionsType = {
  '1': "gift",
  '2': 'cashback',
  "3": 'coupon',
  '4': 'dream gift'
}

const TdsOnRedemptions = () => {
  const navigate = useNavigate();
  const location = useLocation();
  // console.log("location at SMS template", location);
  const primaryColor = JSON.parse(sessionStorage.getItem("vendorTheme")).theme
    .color_shades;

  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [paginationResetToggle, setPaginationResetToggle] = useState(false);
  const [csvData, setCsvData] = useState(null);

  const [myList, setMyList] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [allZones, setAllZones] = useState([]);
  const [userTypesArray, setUserTypesArray] = useState({
    name: "All",
    id: null,
  });

  const [userTypeId, setUserTypeId] = useState(userTypesArray.id);

  const currentDate = new Date().toISOString().split("T")[0];
  const [userZone, setUserZone] = useState({
    name: "All Zones",
    id: 0,
  });

  const initialRequest = {
    name: "",
    mobile: "",
    user_type_id: userTypeId,
    limit: 10,
    offset: 0,
    startDate: "",
    endDate: "",
  };
  const [request, setRequest] = useState(initialRequest);
  const clearFilters = () => {
    setRequest(initialRequest);
    setUserZone({
      name: "All Zones",
      id: 0,
    });
  };

  const [
    fetchRedemptionHistory,
    { data: redemptionHistoryData, error: redemptionHistoryError },
  ] = useFetchRedemptionHistoryForTDSMutation();

  const [
    fetchRedemptionHistoryCsv,
    { data: redemptionHistoryCsvData, error: redemptionHistoryCsvError },
  ] = useFetchRedemptionHistoryForTDSMutation();
  const [
    fetchRedemptionHistoryCount,
    { data: redemptionHistoryCountData, error: redemptionHistoryCountError },
  ] = useFetchRedemptionHistoryCountForTDSMutation();

  const handleFetchRedemptionHistoryCsv = () => {
    const modifiedRequest = {
      ...request,
      limit: null,
      offset: null,
    };
    fetchRedemptionHistoryCsv({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      body: modifiedRequest,
      zoneId: userZone.id,
    });
  };

  const handleFetchRedemptionHistory = () => {
    fetchRedemptionHistory({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      body: request,
      zoneId: userZone.id,
    });
  };

  const handleFetchRedemptionCountHistory = () => {
    fetchRedemptionHistoryCount({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      body: request,
      zoneId: userZone.id,
    });
  };
  useEffect(() => {
    const hasViewPermission = hasPermission("tdsCalculationOnRedemptions");
    if (!hasViewPermission) {
      navigate(`/genefied/${getVendorName()}/`);
    }

    handleFetchRedemptionCountHistory();
  }, []);

  useEffect(() => {
    if (redemptionHistoryCsvData && redemptionHistoryCsvData?.body?.data) {
      console.log("csvData", redemptionHistoryCsvData?.body?.data);
      setCsvData(redemptionHistoryCsvData?.body?.data);
    }

    if (redemptionHistoryCsvError) {
      setCsvData(null);
    }
  }, [redemptionHistoryCsvData, redemptionHistoryCsvError]);


  useEffect(() => {
    handleFetchRedemptionHistory();
  }, [limit, offset]);

  useEffect(() => {
    if (redemptionHistoryData) {
      console.log("redemption history", redemptionHistoryData);
      setMyList(
        redemptionHistoryData.body && redemptionHistoryData.body.data
          ? redemptionHistoryData.body.data
          : []
      );
    }

    if (redemptionHistoryError) {
      console.log("redemtion error", redemptionHistoryError);
    }
  }, [redemptionHistoryData, redemptionHistoryError]);

  useEffect(() => {
    if (redemptionHistoryCountData) {
      console.log("redemptionHistoryCountData", redemptionHistoryCountData);

      setTotalRows(
        redemptionHistoryCountData.body && redemptionHistoryCountData.body.total
          ? redemptionHistoryCountData.body.total
          : 0
      );
    }

    if (redemptionHistoryCountError) {
      console.log("redemptionHistoryCountError", redemptionHistoryCountError);
    }
  }, [redemptionHistoryCountData, redemptionHistoryCountError]);

  const columns = [
    {
      name: "SNo",
      cell: (row, idx) => offset + Number(idx + 1),
      sortable: true,
      width: "70px",
    },
    {
      name: "Name",
      cell: (row) => row.name,
      sortable: true,
      width: "120px",
    },
    {
      name: "Mobile",
      cell: (row) => row.mobile,
      sortable: true,
      width: "120px",
    },
    {
      name: "Usertype",
      cell: (row) => row.user_type,
      sortable: true,
      width: "115px",
    },
    // {
    //   name: "Platform",
    //   cell: (row) => row.platform,
    //   sortable: true,
    //   width: "120px",
    // },
    {
      name: "Balance On Redemption",
      cell: (row) => row?.balance_on_redemption ? formatter.format(row.balance_on_redemption) : null,
      sortable: true,
      width: "190px",

    },
    {
      name: "Redeemed Points",
      cell: (row) => row?.redeemed_points ? formatter.format(row.redeemed_points) : null,
      sortable: true,
      width: "150px",
    },
    {
      name: "Balance Before TDS",
      cell: (row) => row.balance_before_tds ? formatter.format(row.balance_before_tds) : null,
      sortable: true,
      width: "180px",
    },
    {
      name: "Taxed Amount",
      cell: (row) => row?.taxed_amount ? formatter.format(row.taxed_amount) : null,
      sortable: true,
      width: "130px",
    },
    {
      name: "Tds Amount",
      cell: (row) => row?.tds_amount ? formatter.format(row.tds_amount) : null,
      sortable: true,
      width: "130px",
    },
    {
      name: "Balance After TDS",
      cell: (row) => row?.balance_after_tds ? formatter.format(row.balance_after_tds) : null,
      sortable: true,
      width: "180px",
    },
    {
      name: "Redemtion Type",
      cell: (row) => (redemptionsType[row.redemption_type]),
      sortable: true,
    },
   
    // {
    //   name: "TDS Deducted",
    //   cell: (row) => row.tds_deducted,
    //   sortable: true,
    //   width: "140px",
    // },
    {
      name: "Ref No",
      cell: (row) => row.ref_no,
      sortable: true,
    },

    {
      name: "Status",
      cell: (row) =>
        row.approval_status == '2' ? (
          <button
            className="text-red-500"
          >
            REJECTED
          </button>
        ) :
          row.approval_status == "3" ? (
            <button

              className="text-gray-500"
            >
              PENDING

            </button>
          ) : (
            <button className="text-green-400">
              {/* <AiOutlineEdit className="mr-1" /> */}
              ACCECPTED
            </button>
          ),

      sortable: true,
    },
    {
      name: "Tds Deducted At",
      cell: (row) => row.tds_deducted_at ? new Date(row.tds_deducted_at).toLocaleString() : "",
      sortable: true,
    },
    // {
    //   name: "Created At",
    //   cell: (row) => new Date(row.created_at).toLocaleString(),
    //   sortable: true,
    // },
  ];

  const handlePageChange = (pageNumber) => {
    const newOffset = (pageNumber - 1) * limit;
    setOffset(newOffset);
    setRequest((prevRequest) => ({ ...prevRequest, offset: newOffset }));
    setCurrentPage(pageNumber);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setRequest((prevRequest) => ({
      ...prevRequest,
      limit: newPerPage,
      offset: 0,
    }));
    setLimit(newPerPage);
    setOffset(0);
    setCurrentPage(1);
    setPaginationResetToggle((prev) => !prev);

  };

  return (
    <>
      <div className="flex w-full bg-gray-200 h-full justify-center">
        <div className="w-full ">
          <div className="border-b bg-white border-gray-300 pl-6 py-2 shadow-sm text-xl font-bold">
            TDS Calculation on Redemptions
            <LinksComponent />
          </div>

          <div className="p-3">
            {/* {redemptionHistoryCsvData &&
            redemptionHistoryCsvData?.body?.data && (
              <ExportCSV
                data={
                  redemptionHistoryCsvData &&
                  redemptionHistoryCsvData?.body?.data
                }
                columnsToExport={[
                  "name",
                  "email",
                  "mobile",
                  "user_type",
                  "points",
                  "redemption_type",
                  "ref_no",
                  "gift.gift[0].name"
                ]}
              />
            )} */}

            <div className="mb-2">
              <CustomExport
                fetchData={handleFetchRedemptionHistoryCsv}
                data={csvData}
                defaultColumnExport={[
                  "name",
                  "email",
                  "mobile",
                  "user_type",
                  "points",
                  "redemption_type",
                  "ref_no",
                  "gift.gift[0].name",
                ]}
                filename="redeem_request"
              />
            </div>
            <div className="border-b  border-gray-300 bg-gray-50 rounded-t-lg p-3">
              <div className="flex  space-x-2 ">
                <div className="w-52">
                  <div className="relative searchin">
                    <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                      Name
                    </label>
                    <input
                      type="search"
                      id="default-search"
                      className="w-full p-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                      placeholder="Name..."
                      required
                      value={request.name}
                      onChange={(e) => {
                        const newValue = e.target.value;
                        setRequest((prevState) => {
                          return { ...prevState, name: newValue };
                        });
                      }}
                    />
                  </div>
                </div>

                <div className="w-52">
                  <div className="relative searchin">
                    <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                      Mobile
                    </label>
                    <input
                      type="search"
                      id="default-search"
                      className="w-full p-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                      placeholder="Mobile No..."
                      required
                      value={request.mobile}
                      onChange={(e) => {
                        const newValue = e.target.value;
                        setRequest((prevState) => {
                          return { ...prevState, mobile: newValue };
                        });
                      }}
                    />
                  </div>
                </div>

                <div className="w-52">
                  <div className="relative searchin topslt">
                    <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                      Zones
                    </label>
                    <div className="relative searchin">
                      <SelectComponent
                        placeholder={"Select Zone*"}
                        selected={userZone}
                        setSelected={setUserZone}
                        dataArr={allZones}
                      />
                    </div>
                  </div>
                </div>

                <div className="w-52 searchin">
                  <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                    From Date
                  </label>
                  <input
                    type="date"
                    className="w-full  text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                    placeholder=""
                    value={request.startDate}
                    onChange={(e) => {
                      const newValue = e.target.value;
                      setRequest((prevState) => {
                        return {
                          ...prevState,
                          startDate: newValue,
                        };
                      });
                    }}
                  />
                </div>

                <div className="w-52 searchin">
                  <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                    End Date
                  </label>
                  <input
                    type="date"
                    className="w-full  text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                    placeholder=""
                    value={request.endDate}
                    onChange={(e) => {
                      const newValue = e.target.value;
                      setRequest((prevState) => {
                        return {
                          ...prevState,
                          endDate: newValue,
                        };
                      });
                    }}
                  />
                </div>

                <div className="">
                  <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                    &nbsp;
                  </label>
                  <div className="relative searchin gap-2 flex">
                    <button
                      className="py-2 btn btn-outline-primary clear-both float-right  pdbtn_all"
                      onClick={() => {
                        handleFetchRedemptionHistory();
                        handleFetchRedemptionCountHistory();
                      }}
                    >
                      Search
                    </button>

                    <button
                      className="btn btn-outline-primary clear-both float-right pdbtn_all whitespace-nowrap"
                      onClick={() => {
                        clearFilters();
                      }}
                    >
                      Clear Filter
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="p-3 bg-white shadow rounded-lg">
              <DataTableComponent
                keyField={(row) => row.SNo}
                columns={columns}
                // title={""}
                data={myList}
                // loading={loading}
                totalRows={totalRows}
                handlePerRowsChange={handlePerRowsChange}
                handlePageChange={handlePageChange}
                paginationDefaultPage={currentPage}
                paginationResetDefaultPage={paginationResetToggle}
              ></DataTableComponent>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TdsOnRedemptions;
